import Header from "./components/Header";
import Introduction from "./components/Introduction";
import Facilities from "./components/Facilities";
import Advantages from "./components/Advantages";
import Gallery from "./components/Gallery";
import Review from "./components/Review";
import Articles from "./components/Articles";
import Schedule from "./components/Schedule";
import Footer from "./components/Footer";
import ArrowTop from "./components/ArrowTop";

export default function App() {
  return (
    <div className="font-lato relative bg-blue-50 scroll-smooth" id="app">
      <img
        className=" mt-48 sm:mt-0 sm:-top-32  sm:w-5/6 lg:w-4/6 xl:w-1/2 sm:left-0 absolute opacity-10 min-[1920px]:-mt-32 min-[1920px]:-left-5"
        src="assets/klinikdepan.jpg"
        alt=""
      />
      <Header />
      <Introduction />
      {/* <div className="bg-blue-400 absolute w-screen h-[500px]  -left-5 rotate-[-50deg]   rounded-2xl opacity-10  "></div> */}

      <Facilities />
      <Advantages />
      <Gallery />
      <Review />
      <Articles />
      <Schedule />
      <Footer />
      <ArrowTop />
    </div>
  );
}
